import React, { useState, useEffect, useRef } from 'react';

import { connect } from 'react-redux';

const MAX_IMAGES = 5;
const MAX_SIZE_MB = 5 * 1024 * 1024;

let folderName = 'stage-appointment-images';
if (process.env.REACT_APP_ENVIRO === 'prod') {
    folderName = 'appointment-images';
}

const ImageUpload = (props, { onUploadImage, onDrop, isfrom }) => {
    const {
        dispatch,
        schedule,
        bookingImages,
        vehicle,
    } = props;
    const [images, setImages] = useState([]);
    const [error, setError] = useState("");
    const [base64Images, setBase64Images] = useState(
        bookingImages.length > 0 ? bookingImages : [],
    );
    const [isImageType, setIsImageType] = useState({
        type: 'new',
        old_image_name: '',
        index: 0,
    });
    const [imgError, setImgError] = useState(null);
    const [loading, setLoading] = useState(false);
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024; // Convert MB to bytes
    const fileInputRef = useRef(null);

    // Load from localStorage on mount
    useEffect(() => {
        setImages(base64Images);
    }, []);

    useEffect(() => {
        dispatch({
            type: 'SET_BOOKING_IMAGES',
            bookingImages: base64Images,
        });
    }, [base64Images]);


    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        const { swId } = schedule;
        if (
            base64Images.length + files.length > MAX_IMAGES &&
            isImageType.type !== 'old'
        ) {
            setImgError(`You can only upload up to ${MAX_IMAGES} images.`);
            return;
        }
        // Set loading to true before starting the upload
        setLoading(true);
        const newBase64Images = [];
        let isSizeExceeded = false;
        const newBase64ImagesObject = {};
        files.forEach((file) => {
            if (file.size <= MAX_SIZE_BYTES) {
                const reader = new FileReader();
                const fileExtension = file.name.split('.').pop();
                const { vehicle_id } = vehicle;
                const randomID = Math.floor(Math.random() * 1000000);
                const filename = `${vehicle_id}-${randomID}.${fileExtension}`;
                /* if (changeBooking) {
                  filename = `${swId}-${filename}`;
                } */
                newBase64ImagesObject.fileName = filename;
                newBase64ImagesObject.id = vehicle_id;
                newBase64ImagesObject.originalFileName = null;
                if (isImageType.type === 'old') {
                    newBase64ImagesObject.originalFileName = isImageType.old_image_name;
                    setBase64Images((prevBase64Images) =>
                        prevBase64Images.filter((_, i) => i !== isImageType.index),
                    );
                }
                newBase64ImagesObject.folder = folderName;
                reader.onloadend = () => {
                    newBase64Images.push({
                        fileName: filename,
                        id: vehicle_id,
                        originalFileName: null,
                        folder: folderName,
                        base64: reader.result.substr(reader.result.indexOf(',') + 1),
                        preview: reader.result,
                    });
                    newBase64ImagesObject.base64 = reader.result.substr(
                        reader.result.indexOf(',') + 1,
                    );
                    // Ensure state update happens once all files are read
                    if (newBase64Images.length === files.length) {
                        setBase64Images((prevBase64Images) => [
                            ...prevBase64Images,
                            ...newBase64Images,
                        ]);

                    }
                };

                reader.readAsDataURL(file);
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            } else {
                isSizeExceeded = true;
            }
        });

        if (isSizeExceeded) {
            setImgError(
                `One or more files exceed the size limit of ${MAX_SIZE_MB} MB.`,
            );
        } else {
            setImgError(null);
        }
    };

    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });

    const handleFiles = async (files) => {
        const fileArray = Array.from(files);

        if (images.length + fileArray.length > MAX_IMAGES) {
            setError(`You can upload a maximum of ${MAX_IMAGES} images.`);
            return;
        }

        const oversizedFiles = fileArray.filter((file) => file.size > MAX_SIZE_MB);
        if (oversizedFiles.length > 0) {
            setError("Each file must be 5MB or smaller.");
            return;
        }

        const base64Images = await Promise.all(
            fileArray.map(async (file) => {
                const fileExtension = "png";
                const randomID = Math.floor(Math.random() * 1000000);
                const filename = `${vehicle.vehicle_id}-${randomID}.${fileExtension}`;
                const base64Code = await fileToBase64(file);
                return { identifire: Date.now() + Math.random(), fileName: filename, id: vehicle.vehicle_id, preview: base64Code, isUploaded: true, folder: folderName, originalFileName: null, base64: "" };
            })
        );

        setImages((prev) => [...prev, ...base64Images]);
        setError("");
    };

    const handleFileUpload = (event) => {
        handleFiles(event.target.files);
        event.target.value = null;
    };

    const handleDrop = (event) => {
        event.preventDefault();
        handleFiles(event.dataTransfer.files);
    };

    const removeImage = (identifire) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this image?");
        if (confirmDelete) {
            setImages((prev) => prev.filter((img) => img.identifire !== identifire));
            if (images.length - 1 < MAX_IMAGES) {
                setError("");
            }
        }
    };

    const handleImageRemove = (index) => {
        const updatedItems = [...base64Images];
        // Update the object at the specific index
        const newData = {
            base64: '',
            preview: '',
            originalFileName: updatedItems[index].fileName,
        };
        updatedItems[index] = {
            ...updatedItems[index], // Spread to copy the original object
            ...newData, // Apply the new data
        };
        const isConfirmed = window.confirm(
            'Are you sure want to remove this image?',
        );

        if (isConfirmed) {
            /* if (changeBooking) {
              deleteVehicleImage(updatedItems[index]).then((result) => {
                 if (result.status !== 200) {
                   result.text().then((x) => {
                     setImgError(`Critical Error: ${x}`);
                   });
                   return null;
                 }
               });
            } */
            setBase64Images((prevBase64Images) =>
                prevBase64Images.filter((_, i) => i !== index),
            );

            if (fileInputRef.current) {
                fileInputRef.current.value = ''; // Clear the file input
            }
        }
    };

    return (
        <div style={styles.container}>
            <label
                htmlFor="fileInput"
                style={styles.uploadBox}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
            //   onDrop={(e) => {
            //     if(isfrom == "POPUP"){
            //         handleDrop(e);
            //     }
            //     else if(isfrom == "CONFIRMATION"){
            //         onDrop(e);
            //     }
            //   }}
            >
                <input
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleImageUpload}
                    // onChange={(e) => {
                    //     if(isfrom == "POPUP"){
                    //         handleFileUpload(e);
                    //     }
                    //     else if(isfrom == "CONFIRMATION"){
                    //         onUploadImage(e);
                    //     }
                    //   }}
                    hidden
                    id="fileInput"
                />
                <img src="/static/img/Imagelogo.png" alt="Upload Icon" style={styles.uploadIcon} />
                <span style={styles.uploadLabel}>Upload Image</span>
                <span className="image-Upload-subtitle">Supports: JPG and PNG up to 5MB. Max 5 images.</span>
            </label>

            {/* {error && <div style={styles.errorLabel}>{error}</div>}

            <div style={styles.imageRow}>
                {images.map((image) => (
                    <div key={image.id} style={styles.imageContainer}>
                        <img src={image.preview} alt="Thumbnail" style={styles.thumbnail} />
                        <button
                            style={styles.removeButton}
                            onClick={() => removeImage(image.identifire)}
                            aria-label="Remove image"
                        >
                            ✕
                        </button>
                    </div>
                ))}
            </div> */}
            <div style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
                maxWidth: "400px",
                margin: "0 auto",
                padding: "0px",
                display: "flex", flexWrap: "wrap", gap: "1px", justifyContent: "center"
            }} >
                {loading && <h5 className="image-loader">Loading...</h5>}
                {!loading &&
                    <div style={styles.imageRow}>
                        {base64Images.map((image, index) => (
                            <div key={image.id} style={styles.imageContainer}>
                                <div className="preview_img">
                                    <img src={image.preview} alt="Thumbnail" />
                                </div>
                                <button
                                    style={styles.removeButton}
                                    onClick={() => handleImageRemove(index)}
                                    aria-label="Remove image"
                                >
                                    ✕
                                </button>
                            </div>
                        ))}
                    </div>}
            </div>
            {imgError && <p className="error">{imgError}</p>}
        </div>
    );
};

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: "295px",
        margin: "0 auto",
        padding: "5px",
    },
    uploadBox: {
        width: "290px",
        maxWidth: "295px",
        height: "154px",
        border: "1px dashed lightgray",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        marginBottom: "10px",
        backgroundColor: "#919EAB14",
        textAlign: "center",
        borderRadius: "10px",
        padding: "10px",
    },
    uploadIcon: { width: "40px", height: "40px", marginBottom: "8px" },
    uploadLabel: { fontSize: "14px", fontWeight: "bold", color: "#333", marginBottom: "5px" },
    uploadText: { fontSize: "12px", textAlign: "center", color: "#919EAB", fontWeight: "semibold" },
    errorLabel: {
        color: "red",
        fontSize: "12px",
        marginBottom: "10px",
        fontWeight: "bold",
        textAlign: "center",
        padding: "0px",
    },
    imageRow: { display: "flex", gap: "3x", justifyContent: "left",},
    imageContainer: {
        position: "relative",
        width: "60px",
        height: "60px",
        borderRadius: "2px",
        overflow: "hidden",
        backgroundColor: "#eee",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white"
    },
    thumbnail: { width: "100%", height: "100%", objectFit: "cover", cursor: "pointer" },
    removeButton: {
        position: "absolute",
        top: "2px",
        right: "2px",
        width: "18px",
        height: "18px",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        color: "white",
        border: "none",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "10px",
        fontWeight: "bold",
        cursor: "pointer",
        zIndex: 10,
        transition: "background-color 0.3s ease",
    },
};

function mapStateToProps(state) {
    return {
        account: state.ui.account,
        schedule: state.ui.schedule,
        cart: state.ui.cart,
        diagnostic: state.ui.diagnostic,
        changeBooking: state.ui.changeBooking,
        homeAddress: state.ui.homeAddress,
        customerLocation: state.ui.customerLocation,
        clientLocations: state.ui.clientLocations,
        compatibleDates: state.ui.compatibleDates,
        z3pConfiguration: state.ui.z3pConfiguration,
        keyLocation: state.ui.keyLocation,
        goBack: state.ui.goBack,
        vehicle: state.ui.pricing,
        vehicles: state.ui.vehicles,
        bookingImages: state.ui.bookingImages,
        scheduledWorks: state.ui.scheduledWorks,
    };
}
export default connect(mapStateToProps, null)(ImageUpload);

